<template>
<b-tooltip size="is-large" :label="tagItem.value"  type="is-light"
          position="is-left"
          square>
          <button  :class="className" @mouseover="onTagHover(tagItem.selectionText, tagItem.type)" @mouseleave="onTagHover('',tagItem.type)"> 
      {{truncatedValue(tagItem.value)}}
      <a role="button" tabindex="0" class="delete is-small" @click="onTagRemoved(tagItem, tagItem.type)"></a>
  </button>
    </b-tooltip>

</template>

<script>
export default {
  name: 'ModalWithDelete',
  props: ['tagItem'],
  computed:{
    className() {
        return "button highlight-"+ this.tagItem.type ;
    }
  },
  methods:{
    onTagHover(selectionText, type){
      this.$store.state.currentHighlightType = type;
      this.$store.state.queries[type].items = [selectionText];
    },
    onTagRemoved(tagItem, type){
      this.$store.commit('removeTagItem',tagItem);
      this.$store.state.queries[type].items = [];
      this.$store.selectionText = '';
    },
    truncatedValue(str){
      if(!str){
        return '';
      }
      if(str.length <=35){
        return str;
      }
      
      return str.substring(0,35)+'...';
    }
  }
}
</script>

<style>
.b-tooltip{
  width:100%;
}
</style>